/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { CommonAPI } from '../../../../api/common/responses';
import { capitalize } from '@utils/lodash';

export namespace ActivityDescription {
  export interface Props {
    event: CommonAPI.RoomEvent;
  }
}

export const ActivityDescription: React.FC<ActivityDescription.Props> = ({ event }) => {
  return (
    <div>
      <div>
        {capitalize(event.action)} <strong>{event.target}</strong>
      </div>
      <div>
        <strong>{event.description}</strong>
      </div>
    </div>
  );
};
